import { render, staticRenderFns } from "./PromoWinners.vue?vue&type=template&id=f2e38626&scoped=true&"
import script from "./PromoWinners.vue?vue&type=script&lang=js&"
export * from "./PromoWinners.vue?vue&type=script&lang=js&"
import style0 from "./PromoWinners.vue?vue&type=style&index=0&id=f2e38626&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e38626",
  null
  
)

export default component.exports